import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ProductDataSet} from '../../models/product-data-set';
import {SearchEventsService} from '../search-container/search.service';
import {ProductsGridComponent} from '../products/products-grid/products-grid.component';
import {ProductService} from '../../services/product.service';
import {Attribute} from '../../models/attribute';

@Component({
    selector: 'app-product-browser',
    templateUrl: './product-browser.component.html',
    styleUrls: ['./product-browser.component.css']
})
export class ProductBrowserComponent implements OnInit, OnDestroy, AfterViewInit {


    @ViewChild('gridComponent') gridComponent: ProductsGridComponent;
    id;
    isSearchGrid = false;
    searchKeyword = '';
    dataset: ProductDataSet = new ProductDataSet();

    searchTriggeredEvent = null;
    storeId = 1;

    filterChanged;
    categoryfilterChanged;
    attributes: Attribute[] = [];
    filterArr: ({ attr_label: string; options: ({ option_label: string; option_id: number } | { option_label: string; option_id: number } | { option_label: string; option_id: number } | { option_label: string; option_id: number })[]; attr_tyoe: string; attr_id: number } | { attr_label: string; options: ({ option_label: string; option_id: number } | { option_label: string; option_id: number } | { option_label: string; option_id: number } | { option_label: string; option_id: number })[]; attr_tyoe: string; attr_id: number })[];

    constructor(private route: ActivatedRoute,
                private searchEventsService: SearchEventsService,
                private productService: ProductService
    ) {

        this.filterChanged = productService.ProductFilterChangedEvent$.subscribe(result => {

            const obj = {
                'category_id': this.id,
                'attr_arr': result
            };


            if (result.length != 0 && this.id != null) {
                this.productService.getProductFiltered(obj).subscribe(data => {
                    if (data.products_csv) {


                        this.dataset = new ProductDataSet();
                        this.dataset.pushParams('entity_id', data.products_csv, 'in');


                        if (this.gridComponent) {
                            this.gridComponent.setProductDataset(this.dataset);
                            this.gridComponent.fetchProductDataSet();
                        }


                    } else {

                        if (this.id) {
                            this.dataset = new ProductDataSet();
                            this.dataset.pushParams('category_id', this.id, 'eq');


                            if (this.gridComponent) {
                                this.gridComponent.setProductDataset(this.dataset);
                                this.gridComponent.fetchProductDataSet();
                            }
                        }

                    }
                })
            } else {
                if (this.id) {
                    this.dataset = new ProductDataSet();
                    this.dataset.pushParams('category_id', this.id, 'eq');


                    if (this.gridComponent) {
                        this.gridComponent.setProductDataset(this.dataset);
                        this.gridComponent.fetchProductDataSet();
                    }
                }

            }
        });

        //
        // this.categoryfilterChanged = productService.ProductCategoryFilterChangedEvent$.subscribe(category_ids => {
        //
        //
        //     if (category_ids.length != 0) {
        //
        //
        //         this.dataset = new ProductDataSet();
        //         this.dataset.pushParams('category_id', category_ids.toString(), 'in');
        //
        //         if (this.gridComponent) {
        //             this.gridComponent.setProductDataset(this.dataset);
        //             this.gridComponent.fetchProductDataSet();
        //         }
        //
        //     }
        // });
    }

    ngOnDestroy(): void {

        // if (this.searchTriggeredEvent) {
        //     this.searchTriggeredEvent.unsubscribe();
        // }

        if (this.filterChanged != null) {
            this.filterChanged.unsubscribe();
        }

        if (this.categoryfilterChanged != null) {
            this.categoryfilterChanged.unsubscribe();
        }

    }

    ngOnInit(): void {


        this.id = this.route.snapshot.paramMap.get('id');

        if (this.id) {
            this.dataset = new ProductDataSet();
            this.dataset.pushParams('category_id', this.id, 'eq');
            this.getCatFilters(this.id, this.storeId);


            if (this.gridComponent) {
                this.gridComponent.setProductDataset(this.dataset);
                this.gridComponent.fetchProductDataSet();
            }
        }


    }

    getCatFilters(category_id, store_id) {
        this.productService.getCategoryFilters(category_id, store_id).subscribe(res => {
            this.attributes = res.attributes;
        });


    }

    ngAfterViewInit(): void {


        // this.searchTriggeredEvent = this.searchEventsService.searchTriggeredEvent.subscribe(keyword => {
        //
        //     const new_dataset = new ProductDataSet();
        //     this.isSearchGrid = true;
        //     this.searchKeyword = keyword;
        //
        //     const keywords_arr = keyword.split(' ');
        //
        //     keywords_arr.forEach(keyword => {
        //
        //         if (keyword == ' ' || keyword == '') {
        //             return;
        //         }
        //
        //         new_dataset.pushParams('name', ('%' + keyword + '%'), 'like');
        //         new_dataset.pushParams('description', ('%' + keyword + '%'), 'like');
        //         new_dataset.pushParams('sku', ('%' + keyword + '%'), 'like');
        //     });
        //
        //     this.dataset = new_dataset;
        //
        // });

    }

}
